/**
 * © 2026 Madar.iq — جميع الحقوق محفوظة
 * هذا الملف جزء من منظومة Madar.iq البرمجية.
 * يُحظر نسخه أو تعديله أو توزيعه دون إذن كتابي.
 * All Rights Reserved — Unauthorized use is prohibited.
 */
import React from "react";
import { useTranslation } from "react-i18next";
import CategoryCard from "./CategoryCard";
import useDragScroll from "./useDragScroll";
import { COLORS } from "./categories.constants";

export default function CategoriesSection() {
  const { t, i18n } = useTranslation();
  const isArabic = i18n.language === "ar";
  const { scrollRef, handleMouseDown, handleWheel } = useDragScroll();

  const rawCategories = t("categories.list", { returnObjects: true });
  const categories = Array.isArray(rawCategories) ? rawCategories : [];

  return (
    <section
      className="py-5"
      style={{
        background: COLORS.gradient,
        direction: isArabic ? "rtl" : "ltr",
        textAlign: "center",
        fontFamily: "'Tajawal', 'Cairo', sans-serif",
        color: COLORS.textLight,
      }}
    >
      <div className="container">
        <h2
          className="fw-bold mb-4"
          style={{
            color: COLORS.gold,
            fontSize: "2.3rem",
            fontFamily: "'Cairo', sans-serif",
          }}
        >
          {t("categories.title")}
        </h2>

        <div
          ref={scrollRef}
          className="categories-scroll-container"
          style={{
            display: "flex",
            gap: "16px",
            padding: "20px 10px 30px",
            overflowX: "auto",
            overflowY: "hidden",
            scrollBehavior: "smooth",
            WebkitOverflowScrolling: "touch",
            scrollbarWidth: "none",
            cursor: "grab",
          }}
          onMouseDown={handleMouseDown}
          onWheel={handleWheel}
        >
          {categories.map((cat, i) => (
            <CategoryCard key={i} icon={cat.icon} name={cat.name} />
          ))}
        </div>

        <style>{`
          .categories-scroll-container::-webkit-scrollbar {
            display: none;
          }
        `}</style>
      </div>
    </section>
  );
}
